import React, { lazy } from 'react';
import Suspense from '../layout/Suspense';

const LazyComponent = lazy(() => import('./DownloadExcel'));

export default () => {
  return <Suspense lazyComponent={<LazyComponent />} />;
};
